import clsx from "clsx";

// Interface
interface OptionsMenuIconProps {
	classes?: string;
	sx?: object;
	disabled?: boolean;
	hoverVariant?: boolean;
}

// MUI
import { SvgIcon } from "@mui/material";

// Images
import { ReactComponent as OptionsIcon } from "@/assets/icons/actions/options.svg";
import { ReactComponent as OptionsHoverIcon } from "@/assets/icons/actions/options_hover.svg";

export default function OptionsMenuIcon(props: Readonly<OptionsMenuIconProps>) {
	const { classes = "", disabled = false, hoverVariant = false, sx = null } = props;

	let icon = OptionsIcon;
	if (hoverVariant) {
		icon = OptionsHoverIcon;
	}

	return (
		<SvgIcon
			inheritViewBox
			component={icon}
			className={clsx({
				[classes]: Boolean(classes),
				"opacity-50": disabled,
			})}
			sx={sx}
		/>
	);
}
